import { Iata, PlatformThemeId } from '@reward-platform/shared-schemas'
import { isClientDeploymentEnv } from '@reward-platform/utils'
import { OpCoMetaConfig } from './types'

const shouldEnableMultiOpCo = isClientDeploymentEnv(['local', 'dev', 'tst'])

const OP_CO_META_CONFIGS: Record<Iata, OpCoMetaConfig> = {
  BA: {
    id: 'british_airways',
    name: 'British Airways',
    programmeIdentifier: 'BAEC',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultCountryCode: 'GB',
    defaultCurrencyCode: 'GBP',
    whitelabelTheme: 'british_airways',
    isAviosEnabled: true,
  },
  EI: {
    id: 'aer_lingus',
    name: 'Aer Lingus',
    programmeIdentifier: 'AERC',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultCountryCode: 'IE',
    defaultCurrencyCode: 'EUR',
    whitelabelTheme: 'aer_lingus',
    // enabled for lower environments for testing
    isAviosEnabled: shouldEnableMultiOpCo,
  },
  IB: {
    id: 'iberia',
    name: 'Iberia',
    programmeIdentifier: 'IBP',
    localeOptions: ['es-ES', 'en-GB'],
    defaultLocale: 'es-ES',
    defaultCountryCode: 'ES',
    defaultCurrencyCode: 'EUR',
    whitelabelTheme: 'iberia',
    // enabled for now but will have feature flag redirect on devcycle
    isAviosEnabled: true,
  },
}

export const DEFAULT_OP_CO: Iata = 'BA'
export const DEFAULT_PLATFORM_THEME: PlatformThemeId = 'avios'

export const getOpCoMetaConfig = (iata: Iata): OpCoMetaConfig => OP_CO_META_CONFIGS[iata]

export const isOpCoEnabledForAvios = (iata: Iata) => OP_CO_META_CONFIGS[iata].isAviosEnabled
